// Module
var code = `<!-- clCallout — visual set-aside.
     Data shape: { variant: "info"|"note"|"warning"|"insight", title?: "plain", content: [ "markdown", ... ] }
     The variant modifier class controls color/icon via SCSS. Title is optional —
     when absent, the wrapper element doesn't render at all. -->
<aside class="block-cl-callout block-cl-callout--{{variant}}">
  <div class="block-cl-callout__icon" aria-hidden="true"></div>
  <div class="block-cl-callout__body">
    {{#title}}<div class="block-cl-callout__title">{{title}}</div>{{/title}}
    <div class="block-cl-callout__content">
      {{#content}}<p>{{.}}</p>{{/content}}
    </div>
  </div>
</aside>
`;
// Exports
module.exports = code;